import { isResourceName } from '@spotify/confidence-core-react';

const WORKFLOW_URI_RE = /^(?:\/\/)?workflows\/([^/]+)\/instances\/([^/]+)$/;

export const parseWorkflowInstanceName = (uri: string): string | undefined => {
  const match = uri.match(WORKFLOW_URI_RE);
  return match ? `workflows/${match[1]}/instances/${match[2]}` : undefined;
};

export const isWorkflowInstanceUri = (uri: string): boolean =>
  parseWorkflowInstanceName(uri) !== undefined;

const SEGMENT_URI_RE = /^(?:\/\/)?segments\/([^/]+)$/;

export const parseSegmentName = (uri: string): string | undefined => {
  const match = uri.match(SEGMENT_URI_RE);
  return match ? `segments/${match[1]}` : undefined;
};

export const isSegmentUri = (uri: string): boolean =>
  parseSegmentName(uri) !== undefined;

const RULE_FLAG_URI_RE = /^(?:\/\/)?(flags\/[^/]+)\/rules\/[^/]+$/;

export const parseRuleParentFlagName = (uri: string): string | undefined => {
  const match = uri.match(RULE_FLAG_URI_RE);
  return match?.[1];
};

export const isRuleUri = (uri: string): boolean => {
  const stripped = uri.replace(/^\/\//, '');
  return isResourceName(stripped, 'rules') || stripped.includes('/rules/');
};
